import React, { useEffect, useState } from "react";
import { Button, Form, Breadcrumb } from "react-bootstrap";
import useReactRouter from "use-react-router"
import * as _ from "lodash"
import { faUserCog } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { COLOR_APP } from "../../constants";
import { useToasts } from 'react-toast-notifications'
import { GET_SETTINGS } from "../../graphql/setting/query";
import { CREATE_SETTING, UPDATE_SETTING } from "../../graphql/setting/mutation";
import { useLazyQuery, useMutation } from "@apollo/client";
import useWindowDimensions from "../../helpers/useWindowDimensions";
import ReactSwitch from "react-switch";

function SettingsLive() {
    const { windowsHeight, windowsWidth } = useWindowDimensions();
    const { height, width } = useWindowDimensions();
    const { addToast } = useToasts()
    const { history } = useReactRouter()
    const [liveSymbol, setLiveSymbol] = useState("=");
    const [liveLimit, setliveLimit] = useState(1);
    const [liveSymbolPost, setLiveSymbolPost] = useState("=");
    const [liveLimitPost, setliveLimitPost] = useState(1);
    const [playNoProduct, setPlayNoProduct] = useState(true);
    const [isSummaryFirst, setIsSummaryFirst] = useState(false);
    const [shopSettings, setShopSettings] = useState();
    const [getSettings, { data: shopSettingData }] = useLazyQuery(GET_SETTINGS, { fetchPolicy: "cache-and-network" });
    const [createSetting, { loading: loadingCreateSetting }] = useMutation(CREATE_SETTING)
    const [updateSetting, { loading: loadingUpdateSetting }] = useMutation(UPDATE_SETTING)
    const [sumLiveOrderPerDay, setSumLiveOrderPerDay] = useState(true);
    const [sumPostOrderPerDay, setSumPostOrderPerDay] = useState(true);
    const [autoReceive, setAutoReceive] = useState(false);

    useEffect(() => {
        initSetting()
    }, [])

    const initSetting = async () => {
        const SHOP_ID = await localStorage.getItem("SHOP");
        await getSettings({
            variables: {
                where: {
                    shop: SHOP_ID,
                },
                orderBy: "createdAt_ASC"
            }
        })
    }

    useEffect(() => {
        if (shopSettingData?.settings?.data?.length > 0) {
            let newShopSetting = JSON.parse(shopSettingData?.settings?.data[0]?.live)
            let newShopSettingPost = JSON.parse(shopSettingData?.settings?.data[0]?.post)
            setSumLiveOrderPerDay(newShopSetting ? (newShopSetting['sumOrderPerDay'] == "false" ? false : true) : true)
            setLiveSymbol(newShopSetting ? newShopSetting?.symbol : "")
            setliveLimit(newShopSetting ? newShopSetting?.limit : 1)
            setPlayNoProduct(newShopSetting ? newShopSetting?.playNoProduct == "true" : true)
            setIsSummaryFirst(shopSettingData?.settings?.data[0]?.isSummaryFirst ?? false)
            setShopSettings(shopSettingData?.settings?.data[0])
            setLiveSymbolPost(newShopSettingPost ? newShopSettingPost?.symbol : "")
            setliveLimitPost(newShopSettingPost ? newShopSettingPost?.limit : 1)
            setSumPostOrderPerDay(newShopSetting ? (newShopSettingPost['sumOrderPerDay'] == "false" ? false : true) : true);
            setAutoReceive(shopSettingData?.settings?.data[0]?.autoReceive ?? false);
        }
    }, [shopSettingData])

    const _saveSetting = async () => {
        const SHOP_ID = await localStorage.getItem("SHOP");
        if (!shopSettings) {
            await createSetting({
                variables: {
                    data: {
                        live: JSON.stringify({
                            symbol: liveSymbol ?? "=",
                            limit: liveLimit || 1,
                            sumOrderPerDay: sumLiveOrderPerDay || 'true',
                            playNoProduct: playNoProduct
                        }),
                        post: JSON.stringify({
                            symbol: liveSymbolPost || "=",
                            sumOrderPerDay: sumPostOrderPerDay || 'true',
                            limit: liveLimitPost || 1
                        }),
                        autoReceive: autoReceive,
                        isSummaryFirst: isSummaryFirst,
                        shop: SHOP_ID
                    }
                }
            })
            initSetting()
            addToast("ຕັ້ງຄ່າຂໍ້ຄວາມສໍາເລັດ", {
                appearance: 'success',
                autoDismiss: true,
            })
        } else {
            await updateSetting({
                variables: {
                    where: {
                        id: shopSettings.id
                    },
                    data: {
                        live: JSON.stringify({
                            symbol: liveSymbol ?? "=",
                            limit: liveLimit ?? 1,
                            sumOrderPerDay: sumLiveOrderPerDay ? "true" : "false",
                            playNoProduct: playNoProduct ? "true" : "false",
                        }),
                        post: JSON.stringify({
                            symbol: liveSymbolPost || "=",
                            sumOrderPerDay: sumPostOrderPerDay ? "true" : "false",
                            limit: liveLimitPost || 1
                        }),
                        autoReceive: autoReceive,
                        isSummaryFirst: isSummaryFirst,
                    }
                }
            })
            initSetting()
            addToast("ຕັ້ງຄ່າຂໍ້ຄວາມສໍາເລັດ", {
                appearance: 'success',
                autoDismiss: true,
            })
        }
    }

    return (
        <div>
            {width > 700 ? (
                <div style={{ background: '#f9f9f9', width: windowsWidth }}>
                    <Breadcrumb>
                        <Breadcrumb.Item onClick={() => history.replace('/settings')}>ຕັ້ງຄ່າ</Breadcrumb.Item>
                        <Breadcrumb.Item active>ຕັ້ງຄ່າການໄລຟ</Breadcrumb.Item>
                    </Breadcrumb>
                    <div style={{ padding: 20, paddingBottom: 0, border: "1px solid #ced4da", borderRadius: 5, background: "#fff", margin: 10 }}>
                        <h5 style={{ color: "#1b1b1b", fontWeight: "bold" }}> <FontAwesomeIcon icon={faUserCog} /> ຕັ້ງຄ່າການ CF ໃນໄລຟ 🚨 </h5>
                        <div className="row">
                            <div className="col-6">
                                <Form.Group controlId="exampleForm.ControlInput1">
                                    <Form.Label>ສັນຍາລັກຂັ້ນຂໍ້ຄວາມຊີເອຟ</Form.Label>
                                    <Form.Control
                                        as="select"
                                        name="selectStatus"
                                        custom
                                        value={liveSymbol}
                                        onChange={e => setLiveSymbol(e?.target?.value ?? "/")}
                                    >
                                        <option value={"="}>= (ເທົ່າກັບ) ຕົວຢ່າງ: A01=2</option>
                                    </Form.Control>
                                </Form.Group>
                                <Form.Group controlId="exampleForm.ControlInput1">
                                    <Form.Label>ຈໍານວນຄັ້ງສາມາດຊີເອຟໄດ້1ໄລຟຕໍ່1ຄົນ</Form.Label>
                                    <Form.Control
                                        type="number"
                                        placeholder="..."
                                        defaultValue={1}
                                        min={1}
                                        value={liveLimit}
                                        onChange={e => setliveLimit(e?.target?.value ?? 1)}
                                    />
                                </Form.Group>
                                <Form.Check
                                    inline
                                    label="ສະແດງສຽງເວລາສິນຄ້າຫມົດ"
                                    name="group1"
                                    onChange={() => setPlayNoProduct(!playNoProduct)}
                                    checked={playNoProduct}
                                    // type={type}
                                    id={`inline-1`}
                                />
                                <Form.Group style={{ display: "flex", flexDirection: 'column' }}>
                                    <h7 style={{ fontWeight: 'bold' }}>ເປີດການໃຊ້ງານລວມອໍເດີ້ເປັນມື້</h7>
                                    <ReactSwitch
                                        checked={sumLiveOrderPerDay}
                                        onChange={() => setSumLiveOrderPerDay(!sumLiveOrderPerDay)}
                                        onColor="#bfbdc7"
                                        onHandleColor="#422f90"
                                        handleDiameter={20}
                                        uncheckedIcon={false}
                                        checkedIcon={false}
                                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                        activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                        height={28}
                                        width={55}
                                        className="react-switch"
                                        id="material-switch"
                                    />
                                </Form.Group>
                                <div style={{ height: 20 }} />
                                <div style={{}}>
                                    <Button style={{ background: COLOR_APP, color: "#ffff", width: "100%" }} onClick={_saveSetting}
                                        disabled={loadingCreateSetting || loadingUpdateSetting}
                                    >
                                        {loadingCreateSetting || loadingUpdateSetting ? "ກຳລັງບັນທຶກ..." : "ບັນທຶກ"}
                                    </Button>
                                </div>
                            </div>
                            <div className="col-6">
                                <p style={{ margin: 0, fontSize: 20, fontWeight: "bold" }}>ຄໍາແນະນໍາການຕັ້ງຄ່າ</p>
                                <p style={{ margin: 0, fontSize: 14, }}>1. ຕັ້ງຄ່າການຂັ້ນຂໍ້ຄວາມຂອງລູກຄ້າເວລາແຊັດໃນໄລຟ ເພື່ອເກັບຂໍ້ມູນໃຫ້ຄົບຖ້ວນ</p>
                                <p style={{ margin: 0, fontSize: 14, }}>2. ຕັ້ງຄ່າລູກຄ້າທີ່ມາຊີເອຟສິນຄ້າເພື່ອປ້ອງກັນການຊີເອຟຊໍ້າ ແລ້ວແຕ່ນະໂຍບາຍຂອງຮ້ານ</p>
                            </div>
                        </div>
                        <div style={{ height: 20 }} />
                    </div>
                    <div style={{ padding: 20, paddingBottom: 0, border: "1px solid #ced4da", borderRadius: 5, background: "#fff", margin: 10 }}>
                        <h5 style={{ color: "#1b1b1b", fontWeight: "bold" }}> <FontAwesomeIcon icon={faUserCog} /> ຕັ້ງຄ່າການ CF ໃນໂພສ 📜</h5>
                        <div className="row">
                            <div className="col-6">
                                <Form.Group controlId="exampleForm.ControlInput1">
                                    <Form.Label>ສັນຍາລັກຂັ້ນຂໍ້ຄວາມຊີເອຟ</Form.Label>
                                    <Form.Control
                                        as="select"
                                        name="selectStatus"
                                        custom
                                        value={liveSymbolPost}
                                        onChange={e => setLiveSymbolPost(e?.target?.value ?? "/")}
                                    >
                                        <option value={"="}>= (ເທົ່າກັບ) ຕົວຢ່າງ: A01=2</option>
                                    </Form.Control>
                                </Form.Group>

                                <Form.Group controlId="exampleForm.ControlInput1">
                                    <Form.Label>ຈໍານວນຄັ້ງສາມາດຊີເອຟໄດ້1ໄລຟຕໍ່1ຄົນ</Form.Label>
                                    <Form.Control
                                        type="number"
                                        placeholder="..."
                                        defaultValue={1}
                                        min={1}
                                        value={liveLimitPost}
                                        onChange={e => setliveLimitPost(e?.target?.value ?? 1)}
                                    />
                                </Form.Group>
                                <Form.Group style={{ display: "flex", flexDirection: 'column' }}>
                                    <h7 style={{ fontWeight: 'bold' }}>ເປີດການໃຊ້ງານລວມອໍເດີ້ເປັນມື້</h7>
                                    <ReactSwitch
                                        checked={sumPostOrderPerDay}
                                        onChange={() => setSumPostOrderPerDay(!sumPostOrderPerDay)}
                                        onColor="#bfbdc7"
                                        onHandleColor="#422f90"
                                        handleDiameter={20}
                                        uncheckedIcon={false}
                                        checkedIcon={false}
                                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                        activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                        height={28}
                                        width={55}
                                        className="react-switch"
                                        id="material-switch"
                                    />
                                </Form.Group>
                                <div style={{ height: 20 }} />
                                <div style={{}}>
                                    <Button style={{ background: COLOR_APP, color: "#ffff", width: "100%" }} onClick={_saveSetting}
                                        disabled={loadingCreateSetting || loadingUpdateSetting}
                                    >
                                        {loadingCreateSetting || loadingUpdateSetting ? "ກຳລັງບັນທຶກ..." : "ບັນທຶກ"}
                                    </Button>
                                </div>
                            </div>
                            <div className="col-6">
                                <p style={{ margin: 0, fontSize: 20, fontWeight: "bold" }}>ຄໍາແນະນໍາການຕັ້ງຄ່າ</p>
                                <p style={{ margin: 0, fontSize: 14, }}>1. ຕັ້ງຄ່າການຂັ້ນຂໍ້ຄວາມຂອງລູກຄ້າເວລາແຊັດໃນໄລຟ ເພື່ອເກັບຂໍ້ມູນໃຫ້ຄົບຖ້ວນ</p>
                                <p style={{ margin: 0, fontSize: 14, }}>2. ຕັ້ງຄ່າລູກຄ້າທີ່ມາຊີເອຟສິນຄ້າເພື່ອປ້ອງກັນການຊີເອຟຊໍ້າ ແລ້ວແຕ່ນະໂຍບາຍຂອງຮ້ານ</p>
                            </div>
                        </div>
                        <div style={{ height: 20 }} />
                    </div>
                </div >
            ) : (
                <div style={{ marginTop: 50 }}>
                    <Breadcrumb>
                        <Breadcrumb.Item onClick={() => history.replace('/settings')}>ຕັ້ງຄ່າ</Breadcrumb.Item>
                        <Breadcrumb.Item active>ໄລຟ</Breadcrumb.Item>
                    </Breadcrumb>
                    <div style={{ margin: '0px 20px 10px 20px' }}>
                        <div >
                            <p style={{ margin: 0, fontSize: 14, fontWeight: "700" }}>ຄໍາແນະນໍາການຕັ້ງຄ່າ</p>
                            <p style={{ margin: 0, fontSize: 14, }}>1. ຕັ້ງຄ່າການຂັ້ນຂໍ້ຄວາມຂອງລູກຄ້າເວລາແຊັດໃນໄລຟ ເພື່ອເກັບຂໍ້ມູນໃຫ້ຄົບຖ້ວນ</p>
                            <p style={{ margin: 0, fontSize: 14, }}>2. ຕັ້ງຄ່າລູກຄ້າທີ່ມາຊີເອຟສິນຄ້າເພື່ອປ້ອງກັນການຊີເອຟຊໍ້າ ແລ້ວແຕ່ນະໂຍບາຍຂອງຮ້ານ</p>
                        </div>
                        <div style={{ marginTop: 5 }}>
                            <Form.Group controlId="exampleForm.ControlInput1">
                                <Form.Label>ສັນຍາລັກຂັ້ນຂໍ້ຄວາມຊີເອຟ</Form.Label>
                                <Form.Control
                                    as="select"
                                    name="selectStatus"
                                    custom
                                    value={liveSymbol}
                                    onChange={e => setLiveSymbol(e?.target?.value ?? "/")}
                                >
                                    <option value={"="}>= (ເທົ່າກັບ) ຕົວຢ່າງ: A01=2</option>
                                </Form.Control>
                            </Form.Group>

                            <Form.Group controlId="exampleForm.ControlInput1">
                                <label style={{ display: 'flex', marginTop: 5, marginBottom: 0, paddingTop: 15 }}>ຕົວເລືອກ <p style={{ color: "red" }}>*</p></label>
                                <Form.Control
                                    type="number"
                                    placeholder="..."
                                    defaultValue={1}
                                    min={1}
                                    value={liveLimit}
                                    onChange={e => setliveLimit(e?.target?.value ?? 1)}
                                />
                            </Form.Group>
                            <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", marginBottom: 20 }}>
                                <div>ສະແດງສຽງເວລາສິນຄ້າຫມົດ</div>
                                {/* <Form.Check
                                  onChange={() => setPlayNoProduct(!playNoProduct)}
                                  type="checkbox"
                                  checked={playNoProduct}
                              /> */}

                                <div className="form-check form-switch">
                                    <input className="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckChecked" checked={playNoProduct} onChange={() => setPlayNoProduct(!playNoProduct)} />
                                </div>
                            </div>
                            <Form.Group style={{ display: "flex", flexDirection: 'column' }}>
                                <h5 style={{ fontWeight: 'bold' }}>ເປີດການໃຊ້ງານລວມອໍເດີ້ເປັນມື້</h5>
                                <ReactSwitch
                                    checked={sumLiveOrderPerDay}
                                    onChange={() => setSumLiveOrderPerDay(!sumLiveOrderPerDay)}
                                    onColor="#bfbdc7"
                                    onHandleColor="#422f90"
                                    handleDiameter={20}
                                    uncheckedIcon={false}
                                    checkedIcon={false}
                                    boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                    activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                    height={28}
                                    width={55}
                                    className="react-switch"
                                    id="material-switch"
                                />
                            </Form.Group>
                        </div>

                        <div >
                            <p style={{ margin: 0, fontSize: 14, fontWeight: "700" }}>ຄໍາແນະນໍາການຕັ້ງຄ່າ</p>
                            <p style={{ margin: 0, fontSize: 14, }}>1. ຕັ້ງຄ່າການຂັ້ນຂໍ້ຄວາມຂອງລູກຄ້າເວລາແຊັດໃນໄລຟ ເພື່ອເກັບຂໍ້ມູນໃຫ້ຄົບຖ້ວນ</p>
                            <p style={{ margin: 0, fontSize: 14, }}>2. ຕັ້ງຄ່າລູກຄ້າທີ່ມາຊີເອຟສິນຄ້າເພື່ອປ້ອງກັນການຊີເອຟຊໍ້າ ແລ້ວແຕ່ນະໂຍບາຍຂອງຮ້ານ</p>
                        </div>
                        <div style={{ marginTop: 25 }}>
                            <Form.Group controlId="exampleForm.ControlInput1">
                                <Form.Label>ສັນຍາລັກຂັ້ນຂໍ້ຄວາມຊີເອຟ</Form.Label>
                                <Form.Control
                                    as="select"
                                    name="selectStatus"
                                    custom
                                    value={liveSymbolPost}
                                    onChange={e => setLiveSymbolPost(e?.target?.value ?? "/")}
                                >
                                    <option value={"="}>= (ເທົ່າກັບ) ຕົວຢ່າງ: A01=2</option>
                                </Form.Control>
                            </Form.Group>

                            <Form.Group controlId="exampleForm.ControlInput1">
                                <label style={{ display: 'flex', marginTop: 5, marginBottom: 0, paddingTop: 15 }}>ຕົວເລືອກ <p style={{ color: "red" }}>*</p></label>
                                <Form.Control
                                    type="number"
                                    placeholder="..."
                                    defaultValue={1}
                                    min={1}
                                    value={liveLimitPost}
                                    onChange={e => setliveLimitPost(e?.target?.value ?? 1)}
                                />
                            </Form.Group>
                            <Form.Group style={{ display: "flex", flexDirection: 'column' }}>
                                <h5 style={{ fontWeight: 'bold' }}>ເປີດການໃຊ້ງານລວມອໍເດີ້ເປັນມື້</h5>
                                <ReactSwitch
                                    checked={sumPostOrderPerDay}
                                    onChange={() => setSumPostOrderPerDay(!sumPostOrderPerDay)}
                                    onColor="#bfbdc7"
                                    onHandleColor="#422f90"
                                    handleDiameter={20}
                                    uncheckedIcon={false}
                                    checkedIcon={false}
                                    boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                    activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                    height={28}
                                    width={55}
                                    className="react-switch"
                                    id="material-switch"
                                />
                            </Form.Group>
                            <div style={{ marginTop: 10 }}>
                                <Button style={{ background: COLOR_APP, color: "#ffff", width: "100%", alignItems: "end" }} onClick={_saveSetting}>ບັນທຶກ</Button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* //TODO Setting Auto Reply Order Confirm */}
            <div style={{ padding: 20, paddingBottom: 0, border: "1px solid #ced4da", borderRadius: 5, background: "#fff", margin: 10 }}>
                <h5 style={{ color: "#1b1b1b", fontWeight: "bold" }}> ຕັ້ງຄ່າການ ຮັບຍອດອັດຕະໂນມັດ <span role="img" aria-label="auto-receive">♻️📤</span></h5>
                <div className="row">
                    <div className="col-6">
                        
                        <Form.Group style={{ display: "flex", flexDirection: 'column' }}>
                            <h7 style={{ fontWeight: 'bold' }}>ເປີດການໃຊ້ງານ ຮັບຍອດອັດຕະໂນມັດ</h7>
                            <ReactSwitch
                                checked={autoReceive}
                                onChange={() => setAutoReceive(!autoReceive)}
                                onColor="#bfbdc7"
                                onHandleColor="#422f90"
                                handleDiameter={20}
                                uncheckedIcon={false}
                                checkedIcon={false}
                                boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                height={28}
                                width={55}
                                className="react-switch"
                                id="material-switch"
                            />
                        </Form.Group>
                        <div style={{ height: 20 }} />
                        <div style={{}}>
                            <Button style={{ background: COLOR_APP, color: "#ffff", width: "100%" }} onClick={_saveSetting}
                                disabled={loadingCreateSetting || loadingUpdateSetting} >
                                {loadingCreateSetting || loadingUpdateSetting ? "ກຳລັງບັນທຶກ..." : "ບັນທຶກ"}
                            </Button>
                        </div>
                    </div>
                    <div className="col-6">
                        <p style={{ margin: 0, fontSize: 20, fontWeight: "bold" }}>ຄໍາແນະນໍາການຕັ້ງຄ່າ</p>
                        <p style={{ margin: 0, fontSize: 14, }}>ຈະມີການຕອບຂໍຄວາມອັດຕະໂນມັດ ຫລັງຈາກການຊຳລະເງີນ</p>
                    </div>
                </div>
                <div style={{ height: 20 }} />
            </div>
        </div>
    );
}

export default SettingsLive;